<skl-dialog-content-ins [isReady]="isFormReady">
    <ins-header id="purchase-payment-dialog-header">
        <ins-toolbar>
            <ins-title class="modal__title">
                <span class="align--tiny-right" id="purchase-payment-dialog-header-title">
                    {{ 'scenes.shared.dialogs.purchase-service-payment-dialog.title' | translate }}
                </span>
                @if (viewModel) {
                    <a
                        class="document-payment-dialog__link link link--blue display--nowrap"
                        [tooltip]="data.entity.documentNumber"
                        id="purchase-payment-dialog-header-document-number"
                        [routerLink]="viewModel.getDocumentRoute().url! | sklCompanyLink"
                        [queryParams]="viewModel.getDocumentRoute().params">
                        {{ data.entity.documentNumber }}
                    </a>
                }
            </ins-title>
            <button
                slot="end"
                id="purchase-payment-dialog-header-cancel-button"
                type="button"
                tabindex="-1"
                class="ins-close-btn"
                (click)="onCancel()">
                <skl-icon name="cross"></skl-icon>
            </button>
        </ins-toolbar>
    </ins-header>

    <ins-content>
        <skl-form-container>
            @if (viewModel && viewModel.bo) {
                <div class="grid" [sklValidationSource]="viewValidation">
                    <div class="col-1">
                        <div class="col-1-2">
                            <ins-form-field
                                [label]="'scenes.shared.dialogs.purchase-service-payment-dialog.form.date.label' | translate">
                                <ins-datepicker
                                    [(ngModel)]="viewModel.payment.date"
                                    id="purchase-payment-dialog-date"
                                    [sklValidate]="'date.' + viewModel.payment.sun">
                                </ins-datepicker>
                            </ins-form-field>
                        </div>
                        <div class="col-1-2">
                            <ins-form-field
                                class="display--flex-auto"
                                [label]="'scenes.shared.dialogs.purchase-service-payment-dialog.form.value.label' | translate">
                                <ins-input
                                    inputmode="decimal"
                                    [(ngModel)]="viewModel.payment.value"
                                    id="purchase-payment-dialog-payment"
                                    [precision]="viewModel.currency.precision"
                                    [sklValidate]="'value.' + viewModel.payment.sun">
                                </ins-input>
                                <div
                                    slot="end"
                                    id="purchase-payment-dialog-payment-preview"
                                    [sklValidateInner]="{key: 'value.' + viewModel.payment.sun, option: 'disable'}">
                                    {{ viewModel.currency.symbol }}
                                </div>
                            </ins-form-field>
                        </div>
                        <div class="col-1">
                            <ins-checkbox
                                class="checkbox--flattened"
                                [(ngModel)]="viewModel.payment.onDocument"
                                id="purchase-payment-dialog-on-document"
                                [disabled]="viewModel.isEInvoiceDocument"
                                [sklValidate]="'onDocument.' + viewModel.payment.sun"
                                [label]="'scenes.shared.dialogs.purchase-service-payment-dialog.form.on-document.label' | translate">
                            </ins-checkbox>
                        </div>
                    </div>
                </div>
            }
        </skl-form-container>
    </ins-content>

    <ins-footer class="dialog__buttons">
        <skl-button
            id="purchase-payment-dialog-cancel-button"
            (click)="onCancel()">
            {{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
        </skl-button>
        <skl-button
            id="purchase-payment-dialog-save-button"
            typeName="accent"
            [spinner]="viewModel?.isSaving!"
            (click)="viewModel?.save()!">
            {{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
        </skl-button>
    </ins-footer>
</skl-dialog-content-ins>
